import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {CssBaseline} from '@material-ui/core';
import {BrowserRouter as Router} from 'react-router-dom'
import { createMuiTheme, ThemeProvider, responsiveFontSizes} from '@material-ui/core/styles';

let theme=createMuiTheme({
  palette:{
    primary:{
      main:'#0a192f',
      light:'#303c55',
      dark:'#172a45'
    },
    secondary:{
      main:'#64ffda',
      light:'#303c55',
      dark:'#172a45'
    }
  }
}) 
theme = responsiveFontSizes(theme);

ReactDOM.render(
  <ThemeProvider theme={theme}>

  <Router>
    <CssBaseline />
    <App />
  </Router>
  </ThemeProvider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
